import styled from 'styled-components';
import { colors } from "../../../styleguide";
import { mediaQueries } from "../../../utils/device";
import StyledLink from "./StyledLink";
var Label = styled.div.withConfig({
  displayName: "Label",
  componentId: "sc-1kt0r1b-0"
})(["max-width:75px;white-space:nowrap;text-overflow:ellipsis;overflow-x:hidden;font-size:11px;color:", ";@media ", "{max-width:150px;}", ":hover &{text-decoration:underline;}"], function (props) {
  if (props.isActive) {
    return colors.red500;
  } else if (props.isHovering) {
    return colors.grey800;
  }

  return colors.grey700;
}, mediaQueries.medium, StyledLink);
export default Label;
//# sourceMappingURL=Label.js.map